import React, { useEffect } from 'react';

const DiscussionPanel = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: DiscussionPanel is not implemented yet.');
  }, []);
  return (
    <>
  { /*DiscussionPanel */} 
 </>
  );
};

export default DiscussionPanel;
